import { createCompanyAuthClient, createMockAuthClient, type AuthClient } from "@vidario/api-client";

/**
 * Picks the AuthClient the app should use at runtime.
 *
 * - **Real backend** (MSW disabled and `VITE_API_BASE_URL` set): the
 *   `company-auth` adapter — cookie-based JWT against the Django backend.
 * - **Otherwise** (dev default with MSW): `MockAuthClient` backed by the
 *   MSW store. Any seeded user email + password "password" signs you in.
 *
 * The MSW gate matches `main.tsx`: when MSW is intercepting requests there
 * are no `/login/` handlers, so auth must stay on the mock adapter.
 */
export function resolveAuthClient(): AuthClient {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  const mswEnabled =
    import.meta.env.DEV && import.meta.env.VITE_USE_MSW !== "false";
  if (apiBaseUrl && !mswEnabled) {
    return createCompanyAuthClient({ baseUrl: apiBaseUrl });
  }
  return createMockAuthClient();
}
